import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NarrativeSettings.module.scss';
import cx from 'classnames';
import Toggle from '../Toggle/Toggle';

const NarrativeSettings = ({
  username,
  showHeader = true,
  seeStoryLine = 0,
  canEditClips = 0,
  handleStoryLine,
  handleEditClips,
  className,
}) => {
  const { t } = useTranslation();

  const toggleSeeStoryLine = e => {
    const checked = e.target.checked;
    if (!checked) {
      handleEditClips(checked);
    }
    handleStoryLine(checked);
  };

  const toggleEditClips = e => {
    const checked = e.target.checked;
    if (checked) {
      handleStoryLine(checked);
    }
    handleEditClips(checked);
  };

  return (
    <div className={cx(styles.settingsWrapper, className)}>
      {showHeader && <h3 className={styles.header}>{t('video.settings.share.privacy_settings')}</h3>}
      <div className={styles.settingContainer}>
        <p className={styles.settingName}>{t('storyboard.editor.invite_modal.can_see_story')}</p>
        <Toggle id={username ? `read-${username}` : 'read'} size="medium" checked={seeStoryLine} onChange={toggleSeeStoryLine} />
      </div>
      <div className={styles.settingContainer}>
        <p className={styles.settingName}>{t('storyboard.editor.invite_modal.can_edit_clips')}</p>
        <Toggle id={username ? `update-${username}` : 'update'} size="medium" checked={canEditClips} onChange={toggleEditClips} />
      </div>
    </div>
  );
};

export default NarrativeSettings;
